import { IField, IFieldProductSearch, IFieldSearch } from "../Interfaces/IField"

export enum FormInputLevels {
  BUSINESSUNIT = "Business Unit",
  FAMILYGROUP = "Family Group",
  SUPERCAT = "Super Cat",
  SAINID = "Item Number",
  CAT = "Cat",
  SKU = "SKU",
  SUBCAT = "Sub Cat",
  CATALOGNO = "Catalog No",
  SEGMENT = "Segment",
}

export const ERROR_MESSAGES = {
  required: "This field is required",
  noRecordsFound: "No records found, try with different search criteria"
}

export const FIELDS: IField = {
  businessUnit: { name: "businessUnit", rules: ["required"] },
  familyGroup: { name: "familyGroup", rules: ["required"] },
  superCat: { name: "superCat", rules: ["required"] },
  sainID: { name: "sainID", rules: ["required"] },
  cat: { name: "cat", rules: ["required"] },
  sku: { name: "sku", rules: ["required"] },
  subCat: { name: "subCat", rules: ["required"] },
  catalogNo: { name: "catalogNo", rules: [] },
  segment: { name: "segment", rules: ["required"] },
}
export const FIELDSFORFAMILYGROUPSEARCH: IFieldSearch = {
  company: { name: "company", rules: [] },
  businessUnit: { name: "businessUnit", rules: [] },
  familyGroup: { name: "familyGroup", rules: [] },
  sainId: { name: "sainId", rules: [] },
  category: { name: "category", rules: [] },
}

export const FIELDSFORPRODUCTSEARCH: IFieldProductSearch = {
  sainId: { name: "sainId", rules: [] },
  sku: { name: "sku", rules: [] },
  familyGroup: { name: "familyGroup", rules: [] },
}
export const PAGE_CHANGED = "PAGE_CHANGED"
export const PAGE_SIZE_CHANGED = "PAGE_SIZE_CHANGED"
export const TOTAL_COUNT_CHANGED = "TOTAL_COUNT_CHANGED"
export const PAGE_SORT = "PAGE_SORT"
export const SEARCH_PAGE_RESET = "SEARCH_PAGE_RESET"
export const PAGE_INITIAL_STATE = "PAGE_INITIAL_STATE"
export const FAMILY_GROUP_ADMIN_VIEW = "api/product/Products?$count=true"
export const PRODUCT_VIEW = "api/product/Products"

//Expected: https://ldm-dev.logisticsapps.js-devops.co.uk/api/product/Products
//Actual:   https://ldm-dev.logisticsapps.js-devops.co.uk/api/product/Products

export const fileUploadOptions = [
  { label: "Family Group Admin Summary", value: '1' },
  { label: "Product", value: '2' },
]

export const AllowedFileTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']

export enum uploadStatus {
  Submitted,
  Picked,
  Processing,
  Fail,
  Succcess
}

export enum FilterCaseConstants {
  FamilySummary = "/familyGroupAdmin/Summary",
  FamilyQuery = "/familyGroupAdmin/Query",
  FamilyManagement = "/familyGroupAdmin/Management",
  ProductQuery = "/product/Query",
  ProductAttributes = "/product/Attributes",
  ProductMeasurementsClothing = "/product/Measurements-Clothing",
  ProductMeasurements = "/product/Measurements",
  ProductHierarchy = "/product/Hierarchy",
  SearchFamilyGoup = "SearchFamilyGoup",
  DuTypeManagement = "/containerTypeMaintenance/Management",
}

export enum DashboardFilterContants {
  FamilyGroupFiltered = "FamilyGroupFiltered",
  FamilyGroupAll = "FamilyGroupAll",
  FamilyGroupParentName = '/familyGroupAdmin',
  FamilyGroupSelectedMenu = 'Summary',
  FamilyGroupPath = "/familyGroupAdmin/summary",
  FamilyGroupHeaderName = "Summary",

  ProductFiltered = "ProductFiltered",
  ProductDailyUpdate = "ProductDailyUpdate",
  ProductParentName = '/product',
  ProductSelectedMenu = 'Query',
  ProductPath = "/product/query",
  ProductHeaderName = "Query"
}

export enum DashBoardQueryType {
  FamilyGroupNotAssinged = 1,
  ProductUpdatedToday,
  NewLineTrue
}